export interface CabecalhoFixo {
    cliente: string;
    filial: string;
    processo: string;
    data: Date;
}

export interface Produto {
    id: number;
    nome: string;
}

export const CABECALHO: CabecalhoFixo = {
    cliente: 'Santander',
    filial: 'Sequoia Recife',
    processo: 'Arquivo Lógico',
    data: new Date()
};

export const PRODUTO: Produto = {
    id: 41,
    nome: 'EPP - Entrega Santander Clique e Retire'
};

export const DEVOLUCOES = [
    { motivo: 'Área de difícil acesso / risco' },
    { motivo: 'Ausente' },
    { motivo: 'Caixa postal' },
    { motivo: 'Cep incorreto' },
    { motivo: 'Destinatário desconhecido' },
    { motivo: 'Em férias' },
    { motivo: 'Encomenda danificada' },
    { motivo: 'Endereço desconhecido' },
    { motivo: 'Endereço errado' },
    { motivo: 'Endereço insuficiente' },
    { motivo: 'Falecido' },
    { motivo: 'Fora do perímetro' },
    { motivo: 'Mudou-se' },
    { motivo: 'Não procurado' },
    { motivo: 'Número inexistente' },
    { motivo: 'Pessoa sem documento' },
    { motivo: 'Recuperado' },
    { motivo: 'Recusado' },
    { motivo: 'Recusado por terceiro' },
    { motivo: 'Zona rural' },
];

export const DADOS_DEVOLUCAO = {
    nome: 'Setor Devolução Bancários B2C',
    endereco: 'Av. Isaltino Victor de Moraes, 437',
    cidadeEstado: 'Vila Bonfim, Embu das Artes/SP',
    cep: '06806-400'
};

export const TIPOS_ACESSO = [
    { id: 1, descricao: 'Admin', disabled: null },
    { id: 2, descricao: 'Cliente', disabled: null },
    { id: 3, descricao: 'Filial', disabled: null },
    { id: 4, descricao: 'Agente', disabled: null}
];

export const RECEPCIONADAS = [
    { descricao: 'Sim', value: 1 },
    { descricao: 'Não', value: 2 },
];
